import { Modal, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Button } from "./Controls/Button";
import { Input } from "./Controls/Input";
import { ImportPaymentReq } from "./Data/ApiTypes";
import { HeaderText } from "./Controls/HeaderText";
import { MoneyInput } from "./Controls/MoneyInput";
import { ImportPaymentReqApi } from "./Data/ApiTransport";
import { parseImportPaymentReq } from "./Data/ApiParse";

interface AddCreditFormModalProps {
    facilityId: number;
    parkerId:   number;
    show:       boolean;
    setShow:    ( show: boolean ) => void;
    onSave:     ( data: ImportPaymentReq ) => void;
}

export function AddCreditFormModal( { facilityId, parkerId, show, setShow, onSave }: AddCreditFormModalProps ) {
    const { register, watch, formState: { errors }, reset, handleSubmit } = useForm<ImportPaymentReqApi>({
        defaultValues: {
            note:   "",
            amount: 0
         }
    } );

    function submit( data: ImportPaymentReqApi ) {
        onSave( parseImportPaymentReq( data ) );
        reset();
        setShow(false);
    }
    const note = watch( "note" );
    return <Modal show={show} centered onEscapeKeyDown={() => setShow(false)}>
        <Form onSubmit={handleSubmit(submit)}>
            <Modal.Header className="fs-5">
                <HeaderText>
                    Add Credit
                </HeaderText>
            </Modal.Header>
            <Modal.Body>
                <Input
                    type="text"
                    label="Note"
                    maxLength={64}
                    placeholder="Ex: Goodwill credit, Promo credit"
                    explanation={`Reason or reference for this credit. ${note.length}/64`}
                    {...register( "note", {
                        required: "Note is required"
                    })}
                    error={errors.note} />

                <MoneyInput
                    label="Amount"
                    inputClassName="text-end"
                    explanation="Credit amount in dollars and cents"
                    min="0"
                    {...register("amount", {
                        valueAsNumber: true,
                        required:      "Amount is required",
                        validate: (value: number) => value != 0 && (!isNaN(value)) || "Please enter a valid number"
                    })}
                    error={errors.amount} />

            </Modal.Body>
            <Modal.Footer className="d-flex">
                <Button className="flex-grow-1" onClick={() => setShow(false)}>Cancel</Button>
                <Button className="flex-grow-1 btn-main" type="submit">Save</Button>
            </Modal.Footer>
        </Form>
    </Modal>;
}
